/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';

  
    const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "542")
  

// 接口文档

  
    
export interface IAPI75922ReqNodesItemTargetTimeObj {
  
  /** -9之前,+9之后 */
  day?: number;
  
  /** hh:mm */
  pointTime?: string;
  
};
    
  
    
export interface IAPI75922ReqNodesItemDeadLineObj {
  
  /** -9之前,+9之后 */
  day?: number;
  
  /** hh:mm */
  pointTime?: string;
  
};
    
  
    
export interface IAPI75922ReqNodesItem {
  
  /** 节点ID */
  nodeId?: string;
  
  /** 父节点ID ,String */
  parentIds?: string[];
  
  /** 是否根节点,true:跟节点,false:普通节点 */
  root?: boolean;
  
  /** 节点名称 */
  nodeName?: string;
  
  /** 节点标签 */
  nodeTag?: string;
  
  /** 节点描述 */
  nodeDesc?: string;
  
  /** 岗位 */
  role?: string;
  
  /** 触发方式 */
  targetType?: string;
  
  /** 触发时间 ,TimeReq */
  targetTime?: IAPI75922ReqNodesItemTargetTimeObj;
  
  /** 截止时间 ,TimeReq */
  deadLine?: IAPI75922ReqNodesItemDeadLineObj;
  
};
    
  
    
export interface IAPI75922ReqLinesItem {
  
  /** 原节点 */
  from?: string;
  
  /** 指向节点 */
  to?: string;
  
  /** 线id */
  id?: string;
  
};
    
  



export interface API75922Req {
  
  /** 数据id */
  dataId: string;
  /** 节点 ,NodeReq */
  nodes: IAPI75922ReqNodesItem[];
  /** 连线 ,LineReq */
  lines: IAPI75922ReqLinesItem[];
};



export type API75922Res = {};


// 接口函数 75922 修改模型拓扑图

export interface IUsePostAPI75922Return {
  /** 修改模型拓扑图: 接口请求状态 */
  isAPI75922Loading: boolean;
  /** 修改模型拓扑图: 接口请求返回数据 */
  dataAPI75922: API75922Res;
  /**  修改模型拓扑图: 接口数据请求方法 */
  fetchAPI75922Data: (inputs: API75922Req, config?: YWRequestConfig) => Promise<API75922Res>;
  /** 修改模型拓扑图: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI75922 = ():IUsePostAPI75922Return => {
  let isMount = true;
  const [isAPI75922Loading, setIsAPI75922Loading] = useState(false);
  const [dataAPI75922, setDataAPI75922] = useState<API75922Res>({} as API75922Res);
  const requestUrl = `${basePath}/yoaichat-web/chat/task/model/update/topology`;

  const fetchAPI75922Data = async (inputs: API75922Req, config?: YWRequestConfig): Promise<API75922Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API75922Req>) || {}) as API75922Req;
    
  
    if ( isMount ) {
      setIsAPI75922Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API75922Res>(`${basePath}/yoaichat-web/chat/task/model/update/topology`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI75922(res || {} as API75922Res);
        setIsAPI75922Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI75922Loading(false);
      }
      return false as unknown as API75922Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI75922Loading,
    dataAPI75922,
    fetchAPI75922Data,
    requestUrl,
  }
}

